<script setup>
import LazyImage from "@/components/atoms/lazy-image";
import Title from "@/components/atoms/titre";
import Button from "@/components/atoms/button";
import Divider from "@/components/atoms/divider";
import LinkTo from "@/components/atoms/link-to";
import Icon from "@/components/atoms/icon";
import masterCard from "@/assets/images/carte-mastercard-2.png";
import malinCard from "@/assets/images/carte-malin-2.png";
import convertionOk from "@/assets/images/carte-carrefour-conversion-ok.png";

const props = defineProps({
  canAddCpay: {
    type: Boolean,
    required: false,
    default: false
  },
  typeCarte: {
    type: String,
    required: true
  },
  isAjoutCompte: {
    type: Boolean,
    required: false,
    default: false
  }
});

const emit = defineEmits(["close", "link"]);
</script>

<template>
  <div class="u-text-center u-pb-sm">
    <template v-if="isAjoutCompte">
      <Icon
        name="check-circle"
        size="lg"
        variant="success"
        class="u-mb-sm"
      />

      <Title
        tag="h2"
        font="secondary"
        variant="primary"
        class="u-mb-sm"
      >Votre Carte Club ou votre Carte PASS a bien été ajoutée !</Title>
    </template>

    <template v-else>
      <LazyImage
        :src="convertionOk"
        alt=""
        width="225"
        class="u-mb-xxs"
      />

      <Title
        tag="h2"
        font="secondary"
        variant="primary"
        class="u-mb-sm"
      >Votre Carte de Fidélité Carrefour ou votre Carte PASS est enregistrée !</Title>
      <p>Votre cagnotte Cora sera automatiquement transférée sur votre Carte Carrefour ou votre Carte PASS dès la fin du programme de fidélité Cora.</p>

      <template v-if="canAddCpay">
        <Divider
          dotted
          size="sm"
          variant="grey-10"
          aria-hidden="true"
          class="u-mt-md"
        />

        <LazyImage
          :src="typeCarte === 'malin' ? masterCard : malinCard"
          alt=""
          width="100"
        />
        <Title
          tag="h2"
          font="secondary"
          variant="primary"
          class="u-mb-sm"
          size="xs"
        >Souhaitez-vous également rattacher votre carte {{ typeCarte === 'malin' ? 'Cora Cpay Mastercard' : 'Malin' }} à votre Carte Carrefour ou votre Carte PASS?</Title>
      </template>

      <Button
        v-if="!canAddCpay"
        size="md"
        variant="primary"
        radius="full"
        class="u-mt-lg"
        @click="emit('close')"
      >Fermer</Button>
      <Button
        v-else
        size="md"
        variant="primary"
        radius="full"
        @click="emit('link')"
      >Je rattache ma carte</Button>
      <br>
      <Button
        v-if="canAddCpay"
        class="u-mt-md"
        link
        @click="emit('close')"
      >
        Je le ferai plus tard
      </Button>
    </template>

  </div>
</template>
